import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  get250w32d89zql9 as get,
  fold2eqrvrnjdby59 as fold,
  minusKeyaa3vrrv8zn1t as minusKey,
  plus3bjhh80fy28if as plus,
  Elementfqwhwe88j543 as Element,
} from '../ExecutionContext.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  return Key_instance;
}
var CacheUrlOverrideClass;
function CacheUrlOverride() {
  if (CacheUrlOverrideClass === VOID) {
    class $ {
      constructor(url) {
        this.t4a_1 = url;
      }
      m3() {
        return Key_instance;
      }
    }
    protoOf($).p48 = get;
    protoOf($).q48 = fold;
    protoOf($).r48 = minusKey;
    protoOf($).t44 = plus;
    initMetadataForClass($, 'CacheUrlOverride', VOID, VOID, [Element()]);
    CacheUrlOverrideClass = $;
  }
  return CacheUrlOverrideClass;
}
//region block: init
Key_instance = new (Key())();
//endregion
//region block: exports
export {
  CacheUrlOverride as CacheUrlOverride1zltsak657aw6,
};
//endregion

//# sourceMappingURL=CacheUrlOverride.mjs.map
